import React, { Component } from 'react';
import { m } from '../../utils';
import './parking.css';

class CurrentTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: m().format('MMMM Do YYYY, h:mm:ss a'),
      timeClock: null,
      scheduleClock: null,
    };
  }

  componentWillMount() {
    this.setState({
      timeClock: setInterval(this.setTime, 1000),
      scheduleClock: setInterval(this.getSchedule, 600000),
    });
  }

  componentWillUnmount() {
    clearInterval(this.state.timeClock);
    clearInterval(this.state.scheduleClock);
  }

  setTime = () => {
    this.setState({ time: m().format('MMMM Do YYYY, h:mm:ss a') });
  };

  getSchedule = () => {
    this.props.retrieveSchedule();
  };

  render() {
    return <h2 className="current-time">{this.state.time}</h2>;
  }
}

export default CurrentTime;



// WEBPACK FOOTER //
// ./src/components/Parking/CurrentTime.js